/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import CloseIcon from './svg/CloseIcon';
import Logo from './Logo';

class NotLoggedInModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: this.props.openRestrictionModal,
    };
  }

  close = () => {
    this.props.closeModal();
  };

  render() {
    return (
      <Modal
        isOpen={this.state.modalIsOpen}
        onAfterOpen={() => {}}
        onRequestClose={() => {}}
        closeTimeoutMS={100}
        className="react-modal"
        overlayClassName="react-modal-overlay"
        contentLabel="Modal"
      >
        <div className="row m-0">
          <div className="col p-0">
            <span className="badge float-right" onClick={this.close}>
              <CloseIcon className="badge-color" />
            </span>
          </div>
        </div>
        <div className="not-login-container">
          <div className="branding">
            <Logo />
          </div>
          <p className="not-login-header">Log in to use Plural!</p>
          <div className="controls">
            <Link onClick={this.close} to="/login">
              <button type="button" className="btn btn-secondary login">
                Log into my account
              </button>
            </Link>
          </div>
          <p>Not a user? Contact us today!</p>
          <div className="controls">
            <a onClick={this.close} href="https://pluralpolicy.com/">
              <button type="button" className="btn btn-secondary signup">
                Schedule a Demo
              </button>
            </a>
          </div>
        </div>
      </Modal>
    );
  }
}

NotLoggedInModal.propTypes = {
  openRestrictionModal: PropTypes.bool,
  closeModal: PropTypes.func.isRequired,
};

export default NotLoggedInModal;
